import React from 'react';
import logger from '../utils/logger';
import { isBenignResizeObserverError } from '../utils/observeElementSize';

const GlobalErrorHandler = ({ children }) => {
  React.useEffect(() => {
    const handleError = (event) => {
      const message = event?.message || event?.error?.message || '';
      // Benign browser/layout noise (React Flow, charts). Don't treat as a fatal app error.
      if (isBenignResizeObserverError(message)) {
        event.preventDefault?.();
        event.stopImmediatePropagation?.();
        return;
      }
      logger.error('Global error caught:', event.error || message);
    };

    const handleUnhandledRejection = (event) => {
      const reason = event.reason;
      if (reason?.name === 'AbortError' || reason?.code === 20) {
        event.preventDefault();
        return;
      }
      const message = reason?.message || reason;
      if (isBenignResizeObserverError(message)) {
        event.preventDefault();
        return;
      }
      logger.error('Unhandled promise rejection:', reason);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return children;
};

export default GlobalErrorHandler;
